(function () {

  'use strict';

  moduleConfig.registerModule('eclipseApp.autoRegSetPassword', ['eclipseApp.core', 'ute.easy.login.registration']);
})();
